import React, {
    useEffect,
    useState,
    useMemo, useContext, useCallback,
} from 'react';
import PropTypes from 'prop-types';
import AdviserContext from "./AdviserContext";
import axios from "axios";
import AuthContext from "../AuthContext";
import {addMonths} from "date-fns";


const AdviserContextProvider = ({
                                    children,
                                }) => {
    const {authToken} = useContext(AuthContext)
    const [isReady, setIsReady] = useState(false);
    const [infoCotizaciones, setInfoCotizaciones] = useState(null);
    const [cotizaciones, setCotizaciones] = useState(null);
    const [emisiones, setEmisiones] = useState(null);
    const [productScope, setProductScope] = useState([]);
    const [dateRange, setDateRange] = useState({
        "startDate": addMonths(new Date(), -2),
        "endDate": new Date(),
    });

    const [modified, setModified] = useState(false);
    const handler = useCallback((range) => {
        if (range !== undefined) {
            setDateRange({
                "startDate": range[0],
                "endDate": range[1],
            })
        }
        setModified(!modified)
    }, [modified]);

    useEffect(() => {

        let shouldUpdate = true;

        const init = async () => {

            let url = process.env.REACT_APP_BACK_SERVER + '/asesoresScope'
            axios.get(url, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authToken}`,
                }
            }).then((responseAsesoresScope) => {
                setProductScope(responseAsesoresScope['data'])

                let url = process.env.REACT_APP_BACK_SERVER + '/getDatosDashboard'
                let data = {
                    "origen": "affinity",
                    "startDate": dateRange['startDate'],
                    "endDate": dateRange['endDate'],
                    "productos_habilitados": responseAsesoresScope['data']
                }

                axios.post(url, data, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${authToken}`,
                    }
                }).then((responseGetDatosDashboard) => {
                    responseGetDatosDashboard['data']['infoCotizaciones'].map((cobertura) => {
                        if (cobertura['id']) {
                            cobertura['idCotizacion'] = cobertura['id']
                        }
                    })
                    setInfoCotizaciones(responseGetDatosDashboard['data']['infoCotizaciones'].sort((a, b) => {
                        return new Date(b.FechaCotizacion) - new Date(a.FechaCotizacion); // descending
                    }))
                    setCotizaciones(responseGetDatosDashboard['data']['cotizaciones'])
                    setEmisiones(responseGetDatosDashboard['data']['emisiones'])
                });
            }).finally(() => {
                setIsReady(true)
            })
        }

        init();
        return () => {
            /* This cleanup function is used to prevent updating the state
            when the component is unmounted */
            shouldUpdate = false;
        };
    }, [authToken, modified])

    const context = useMemo(() => ({
        infoCotizaciones,
        dateRange,
        cotizaciones,
        emisiones,
        productScope,
        handler,
        isReady
    }), [
        infoCotizaciones,
        dateRange,
        cotizaciones,
        productScope,
        handler,
        emisiones,
        isReady
    ]);
    return (
        <AdviserContext.Provider value={context}>
            {children}
        </AdviserContext.Provider>
    );
};

AdviserContextProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export default AdviserContextProvider;